import type { Locale } from '@tuic/i18n';
import { CacheTag } from '../../utils';
import { remember, serializeDataToCacheKey } from '@tuic/cache';
import { Pcl } from '../../index';
import { logger } from '@tuic/logger';

/**
 * Fetches the ship decks from the PCL API.
 */
export const getShipDecks = async (
  shipCode: string,
  locale: Locale,
): Promise<Pcl.ShipDeck[]> => {
  let { data, error } = await Pcl.getShipsByShipCodeDecks({
    path: { shipCode },
    query: { locale },
  });

  if (error) {
    logger.error(
      `Could not fetch ship decks. Ship: ${shipCode}, Locale: ${locale}`,
    );
    logger.error(error);

    return [];
  }

  return data ?? [];
};

/**
 * Cached version of `getShipDecks`.
 */
export const cachedGetShipDecks = (
  shipCode: string,
  locale: Locale,
): Promise<Pcl.ShipDeck[]> =>
  remember(
    serializeDataToCacheKey([CacheTag.pcl, 'getShipDecks', locale, shipCode]),
    () => getShipDecks(shipCode, locale),
    {
      tags: [CacheTag.pcl, CacheTag.shipResource, CacheTag.getShipDecks],
      ttl: 600,
    },
  );
